import { ContextKindKey } from '@gonfalon/contexts/types';

import type { Clause } from './types';

export function formatClauseContextKind(clause: Clause) {
  const { contextKind } = clause;
  switch (contextKind) {
    case ContextKindKey.DEVICE:
      return 'Device';
    case ContextKindKey.APPLICATION:
      return 'Application';
    default:
      return contextKind || ContextKindKey.USER;
  }
}
